import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const TravelTourismManagementCareerSkills = ({ componentData }) => {
  // Parse content into paragraphs (split by double line breaks). Strip the
  // legacy "Discover our…" call-to-action wherever it appears so the section
  // flows cleanly into the new Course Duration / Benefits sections below.
  const paragraphs = (componentData?.content
    ? componentData.content.split(/\n\n+/).filter(p => p.trim())
    : [
        `Travel and Tourism is one of the world's fastest-growing industries, and Tanzania is at the heart of it. At JRIIT, our Travel and Tourism Management program prepares you to build a successful career in this exciting, people-centered field. From hospitality and destination management to event planning and tourism marketing, you will develop the professional skills and industry knowledge needed to thrive in hotels, airlines, tour companies, and beyond — both locally and internationally.`,
        `Why JRIIT? We emphasize hands-on experience with real-world tourism scenarios. You will receive detailed feedback on your customer service skills and tourism management strategies, giving you a complete understanding of your professional development.`,
      ]
  ).filter((p) => !/^\s*discover our\b/i.test(p));

  const title = componentData?.title || "TOURISM-READY SKILLS? CHECK.";

  return (
    <CareerSkillsSection
      title={title}
      paragraphs={paragraphs}
    />
  );
};

export default TravelTourismManagementCareerSkills;
